import React from 'react';
import { Select, SelectProps } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

type IntervalType = 'ANNUAL' | 'HALF_ANNUAL' | 'QUARTERLY' | 'MONTHLY' | 'ONCE';

interface Props {
  excludedValues?: IntervalType[];
}

const CurrencyDurationRightAddon: React.FC<SelectProps & Props> = ({
  excludedValues,
  ...selectProps
}) => {
  const { t } = useTranslation();

  const options: Array<{ value: IntervalType; label: string }> = [
    { value: 'ANNUAL' as IntervalType, label: t('ANNUALLY') },
    { value: 'HALF_ANNUAL' as IntervalType, label: t('HALF_ANNUALLY') },
    { value: 'QUARTERLY' as IntervalType, label: t('QUARTERLY') },
    { value: 'MONTHLY' as IntervalType, label: t('MONTHLY') },
    { value: 'ONCE' as IntervalType, label: t('ONCE') },
  ].filter((option) => !excludedValues?.includes(option.value));

  return (
    <Select
      _focus={{ boxShadow: 'none', outline: 'none' }}
      _focusVisible={{ boxShadow: 'none', outline: 'none' }}
      borderLeft="none"
      borderRight="none"
      borderTopLeftRadius="0"
      borderBottomLeftRadius="0"
      color="black"
      {...selectProps}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};

export default CurrencyDurationRightAddon;
